import * as React from 'react';
import AntDropdown, {
    DropDownProps as AntDropdownProps,
} from 'antd/lib/dropdown';
import './Dropdown.less';
import Styles from './Dropdown.module.less';
import { Button, ButtonProps } from '../Button';
import { FontAwesomeIcon } from '../FontAwesomeIcon';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { classes } from '../../lib/strings';

export type DropdownProps = AntDropdownProps & {
    children?: React.ReactNode;
    size?: ButtonProps['size'];
    text?: React.ReactNode;
    icon?: React.ReactNode;
    onClick?: ButtonProps['onClick'];
    type?: ButtonProps['type'];
    buttonIcon?: React.ReactNode;
    loading?: boolean;
    highlightText?: boolean;
};

// eslint-disable-next-line complexity
export const Dropdown = ({
    text,
    size = 'middle',
    icon,
    children,
    overlay,
    overlayStyle,
    overlayClassName,
    arrow = true,
    className,
    onClick,
    buttonIcon,
    loading,
    type,
    highlightText,
    ...props
}: DropdownProps): JSX.Element => {
    const displayArrow = arrow ? <FontAwesomeIcon icon={faCaretDown} /> : null;
    const displayIcon = icon ?? displayArrow;
    const highlightClass = highlightText ? `alude-blue-6` : undefined;
    const iconArea = displayIcon && (
        <span className={Styles.iconArea}>{displayIcon}</span>
    );

    return (
        <AntDropdown
            {...props}
            overlay={
                <div
                    className={classes(Styles.overlay, overlayClassName)}
                    style={overlayStyle}>
                    {overlay}
                </div>
            }
            prefixCls={Styles.dropdown}>
            {children || (
                <Button
                    loading={loading}
                    type={type}
                    icon={buttonIcon}
                    onClick={onClick}
                    className={classes(className, highlightClass)}
                    size={size}>
                    {text}
                    {iconArea}
                </Button>
            )}
        </AntDropdown>
    );
};
